module.exports = __webpack_public_path__ + "assets/images/bg-77687ee04f9520d0bbcde756604614b2.jpg";